import { createHelpArticleSearch } from "@/lib/help-search";
import { OPERATOR_HELP_ARTICLES } from "@/lib/operator-help/articles";

export const searchOperatorHelpArticles = createHelpArticleSearch(
  OPERATOR_HELP_ARTICLES,
);
